import { cva } from '@/styled-system/css';

export const paragraphRecipe = cva({
  variants: {
    color: {
      'text.invisible': { color: 'transparent.invisible' },
      'text.neutral': { color: 'text.neutral' },
      'text.neutral-fixed': { color: 'text.neutral-fixed' },
      'text.subtle': { color: 'text.subtle' },

      // Legacy values
      'transparent': { color: 'transparent.invisible' },
      'brand': { color: 'blue.400' },
      'brandSecondary': { color: 'yellow.400' },
      'textWhite': { color: 'text.onImpact.neutral-fixed' },
      'textLight': { color: 'gray.400' },
      'textMedium': { color: 'text.subtle' },
      'textDark': { color: 'text.neutral' },
    },
    textStyle: {
      'body-lg': { textStyle: 'body-lg' },
      'body-lg-bold': { textStyle: 'body-lg-bold' },
      'body': { textStyle: 'body' },
      'body-bold': { textStyle: 'body-bold' },
      'body-sm': { textStyle: 'body-sm' },
      'body-sm-bold': { textStyle: 'body-sm-bold' },
      'body-xs': { textStyle: 'body-xs' },
      'body-xs-bold': { textStyle: 'body-xs-bold' },
      'fineprint': { textStyle: 'fineprint' },
      'fineprint-bold': { textStyle: 'fineprint-bold' },
      'fineprint-sm': { textStyle: 'fineprint-sm' },
      'fineprint-sm-bold': { textStyle: 'fineprint-sm-bold' },
    },
  },
});
